import { NavMain } from '@/components/shared/NavMain';
import { NavUser } from '@/components/shared/NavUser';
import { TeamSwitcher } from '@/components/team/TeamSwitcher';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar';
import { useTeamStatus } from '@/hooks/useTeamStatus';
import { useUser } from '@/hooks/useUser';
import { hasAdminPermissions } from '@/utils/permissions';
import { BarChart2, Calendar, Users } from 'lucide-react';
import { type ComponentProps } from 'react';

type AppSidebarProps = ComponentProps<typeof Sidebar>;

export const AppSidebar = ({ ...props }: AppSidebarProps) => {
  const { data: user } = useUser();
  const isAdmin = hasAdminPermissions(user?.role);
  const {
    teamSocialsConnected,
    hasSetupFirstCampaign,
    teamOnboardingComplete,
  } = useTeamStatus();

  const navItems = [
    {
      url: '/',
      title: 'Overview',
      icon: BarChart2,
    },
    ...(hasSetupFirstCampaign
      ? [
          {
            url: '/calendar',
            title: 'Calendar',
            icon: Calendar,
          },
        ]
      : []),
    // ...(teamOnboardingComplete
    //   ? [
    //       {
    //         url: '/reports',
    //         title: 'Reports',
    //         icon: PieChart,
    //       },
    //     ]
    //   : []),
    ...(teamOnboardingComplete && isAdmin
      ? [
          {
            url: '/team/settings',
            title: 'Team',
            icon: Users,
            matchUrl: '/team',
          },
        ]
      : []),
  ];

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher />
      </SidebarHeader>
      <SidebarContent>
        {teamSocialsConnected && <NavMain items={navItems} />}
      </SidebarContent>
      <SidebarFooter>{user && <NavUser user={user} />}</SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};
